import { render, staticRenderFns } from "./ApproveHistory.vue?vue&type=template&id=960b7d0c&scoped=true"
import script from "./ApproveHistory.vue?vue&type=script&lang=js"
export * from "./ApproveHistory.vue?vue&type=script&lang=js"
import style0 from "./ApproveHistory.vue?vue&type=style&index=0&id=960b7d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960b7d0c",
  null
  
)

export default component.exports